/**
 * FieldLabel.tsx
 *
 * Consistent label component for form fields
 */

import React from 'react';

interface FieldLabelProps {
  /** HTML for attribute to associate with input */
  htmlFor?: string;

  /** Label text */
  label: string;

  /** Whether the field is required */
  required?: boolean;

  /** Text alignment */
  alignment?: 'left' | 'center' | 'right';

  /** Additional CSS classes */
  className?: string;
}

export const FieldLabel: React.FC<FieldLabelProps> = ({
  htmlFor,
  label,
  required = false,
  alignment = 'left',
  className = '',
}) => {
  const alignmentClass =
    alignment === 'center'
      ? 'text-center'
      : alignment === 'right'
      ? 'text-right'
      : 'text-left';

  return (
    <label
      htmlFor={htmlFor}
      className={`block ${alignmentClass} ${className}`}
    >
      {label}{' '}
      {required && <span className="text-red-500">*</span>}
    </label>
  );
};
